import { getSettings } from '@app/src/configuration/config.service';

import robotoRegularWoff from '@assets/fonts/Roboto/Roboto-Regular.woff';
import robotoRegularTtf from '@assets/fonts/Roboto/Roboto-Regular.ttf';
                             
import robotoBoldWoff from '@assets/fonts/Roboto/Roboto-Bold.woff';
import robotoBoldTtf from '@assets/fonts/Roboto/Roboto-Bold.ttf';
                            


import MuliRegularWoff from '@assets/fonts/Muli/Muli-Regular.woff';
import MuliRegularTtf from '@assets/fonts/Muli/Muli-Regular.ttf';
                             
import muliBoldWoff from '@assets/fonts/Muli/Muli-Bold.woff';
import muliBoldTtf from '@assets/fonts/Muli/Muli-Bold.ttf';

export function generateFontStyles(): string {
  const staticPath = getSettings().PATH_STATIC;
  return `
    @font-face {
      font-family: roboto-regular;
      src:
        url(${robotoRegularWoff}) format("woff"),
        url(${robotoRegularTtf}) format("truetype");
      font-style: normal;
      font-weight: 100;
    }

    @font-face {
      font-family: roboto-bold;
      src:
        url(${robotoBoldWoff}) format("woff"),
        url(${robotoBoldTtf}) format("truetype");
      font-style: normal;
      font-weight: 200;
    }

    @font-face {
      font-family: muli-regular;
      src:
        url(${MuliRegularWoff}) format("woff"),
        url(${MuliRegularTtf}) format("truetype");
      font-style: normal;
      font-weight: 100;
    }

    @font-face {
      font-family: muli-bold;
      src:
        url(${muliBoldWoff}) format("woff"),
        url(${muliBoldTtf}) format("truetype");
      font-style: normal;
      font-weight: 200;
    }

  `;
}
